var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatures1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#4CAF50",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#4CAF50",
    strokeOpacity: 0.1,
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 19C33.2044 19 32.4413 19.3161 31.8787 19.8787C31.3161 20.4413 31 21.2044 31 22V34C31 34.7956 31.3161 35.5587 31.8787 36.1213C32.4413 36.6839 33.2044 37 34 37C34.7956 37 35.5587 36.6839 36.1213 36.1213C36.6839 35.5587 37 34.7956 37 34C37 33.2044 36.6839 32.4413 36.1213 31.8787C35.5587 31.3161 34.7956 31 34 31H22C21.2044 31 20.4413 31.3161 19.8787 31.8787C19.3161 32.4413 19 33.2044 19 34C19 34.7956 19.3161 35.5587 19.8787 36.1213C20.4413 36.6839 21.2044 37 22 37C22.7956 37 23.5587 36.6839 24.1213 36.1213C24.6839 35.5587 25 34.7956 25 34V22C25 21.2044 24.6839 20.4413 24.1213 19.8787C23.5587 19.3161 22.7956 19 22 19C21.2044 19 20.4413 19.3161 19.8787 19.8787C19.3161 20.4413 19 21.2044 19 22C19 22.7956 19.3161 23.5587 19.8787 24.1213C20.4413 24.6839 21.2044 25 22 25H34C34.7956 25 35.5587 24.6839 36.1213 24.1213C36.6839 23.5587 37 22.7956 37 22C37 21.2044 36.6839 20.4413 36.1213 19.8787C35.5587 19.3161 34.7956 19 34 19Z",
    stroke: "#4CAF50",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatures1);
export default __webpack_public_path__ + "static/media/features1.78d98e13d0be94fd17e964d5657f5c88.svg";
export { ForwardRef as ReactComponent };